import { createContext } from "react"

/** Optional presentation destination for the existing editor's Save/Cancel controls.
 * The editor still owns its callbacks, validation, pending state and captured token.
 */
export const BenefitPanelActions = createContext<HTMLElement | null>(null)
